module.exports = __webpack_public_path__ + "img/img-right-bottom.d459859b.png";